/**
 * @ngdoc directive
 * @module components.carousel
 * @name components.carousel:carousel
 * @scope
 * @restrict E
 * @description
 * Carousel with physics driven animations powered by greensock. Note that it does not currently support infinite scroll.
 * @param {array=} slides Data used to manually set the slides included in the carousel.
 * @param {number=} slideCount The number of slides to show at once. Defaults to 1 if left empty.
 * @param {bool=} auto Causes the carousel to automatically move through its slides if true.
 * @param {number=} autoInterval The time in milliseconds before an autoplaying carousel moves to the next slide.
 * @param {number=} startSlide The index of the slide to start on.
 * @param {function=} onInit Function triggered when the carousel is initialized. Passes the following data to the callback.
 * - ctrl: A reference to the carousel object. Used for cases where carousel methods need to be triggered by an external source.
 * @param {function=} onSlideChange Function triggered when the current slide changes. Passes the following data to the callback.
 * - index: the index of the current slide
 * - slide: the data for the current slide
 * @param {function=} onEdge Function triggered when attempting to move past the first or last slide. Passes the following data to the callback.
 * - direction: 0 if the carousel is moving to the left and 1 if the carousel is moving to the right
 * @example
        <example module="dataExample">
            <file name="index.html">
                <div ng-controller="exampleController">
                    <carousel-sync>
                        <carousel slides="slides">
                            <slide>
                                <h3>{{slide.name}}</h3>
                                <div ng-bind-html="slide.summary"></div>
                            </slide>
                        </carousel>
                    </carousel-sync>
                </div>
            </file>
            <file name="script.js">
                (function() {
                    angular.module('dataExample', ['components.carousel'])
                        .controller('exampleController', exampleController);

                    exampleController.$inject = ['$scope'];
                    function exampleController($scope) {
                        $scope.slides = [];
                        for (var i=0; i<5; i++) {
                            $scope.slides.push({
                                name: 'Slide ' + i,
                                summary: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu pharetra ex. Curabitur eu nunc id dolor laoreet consectetur nec ornare elit. Vivamus elementum turpis ac mi vehicula fermentum. Morbi eget neque justo. Cras id elit condimentum felis vehicula suscipit. Maecenas sagittis pulvinar ante, eu cursus justo placerat ac. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam lacus leo, tristique eu nunc a, placerat placerat tortor. Fusce eget consectetur ante. Suspendisse lobortis dui libero. In ac libero vel eros ultricies auctor nec in felis. Vestibulum sed odio orci.</p><p>Curabitur pellentesque lobortis dui, et luctus ex convallis id. Cras scelerisque augue at imperdiet placerat. In diam velit, congue at diam ut, iaculis feugiat turpis. Donec id elit id elit vestibulum semper. Curabitur quis neque quis ipsum ultricies tincidunt vitae varius lectus. Proin at erat vestibulum, hendrerit urna ac, cursus mi. Cras pulvinar at felis vitae gravida. Nunc egestas rhoncus felis, vel vestibulum nisl condimentum quis. Vestibulum quis iaculis elit.</p>'
                            });
                        }
                    }
                })();
            </file>
        </example>
 */
(function () {
    angular.module('components.carousel', [
    ])
        .component('carousel', {
            require: {
                carouselSync: '?^carouselSync',
                paginator: '?^bmgPagination'
            },
            bindings: {
                slides: '<',
                slideCount: '<?',
                auto: '<?',
                autoInterval: '<?',
                startSlide: '<?',
                route: '@?',
                routeTarget: '@?',
                onInit: '&?',
                onSlideChange: '&?',
                onEdge: '&?'
            },
            controller: CarouselController
        });
    var ids = 1;
    var parentCarousel;
    CarouselController.$inject = ['$scope', '$element', '$attrs', '$transitions', '$stateParams', '$state', '$window', '$timeout', '$q', '$templateRequest', '$compile'];
    function CarouselController($scope, $element, $attrs, $transitions, $stateParams, $state, $window, $timeout, $q, $templateRequest, $compile) {
        var ctrl = this;
        var win, width, slides;
        var slideContent = '';
        ctrl.id = ids++;
        ctrl.$onInit = function () {
            if (!ctrl.autoInterval) {
                ctrl.autoInterval = 8000;
            }
            
            if (!ctrl.slideCount) {
                ctrl.slideCount = 1;
            }
            ctrl.index = ctrl.startSlide || ctrl.index || 0;
            slideContent = angular.element('<div>');
            slideContent.html($element.html());
            ctrl.$$dragDisabled = slideContent.find('carousel').length > 0 || (ctrl.slideCount && ctrl.slides && ctrl.slides.length <= ctrl.slideCount);
            if (ctrl.carouselSync !== null) {
                ctrl.carouselSync.registerCarousel(ctrl);
            }
            if (!parentCarousel)
                parentCarousel = ctrl;
            else if (!ctrl.$$dragDisabled)
                ctrl.parentCarousel = parentCarousel;
            //if (ctrl.slides !== undefined) { //prevents issue caused by slider compilation
            //    ctrl.$$registerTransitions();
            //}
        }

        ctrl.$onChanges = function (changes) {
            if (changes.startSlide && ctrl.slides && ctrl.slides.length > 0) {
                ctrl.goToSlide(changes.startSlide.currentValue, false);
            }
        }

        ctrl.$postLink = function () {
            $templateRequest('/angular/components/carousel/carousel.html', true).then(function (markup) {
                if ($scope.$destroyed)
                    return;
                var html = angular.element(markup);
                ctrl.$$slider = html.find('.slides').find('>div');
                html.find('.slide').html(slideContent.find('>slide').html());
                html.find('.controls').html(slideContent.find('>controls').html());
                $element.html(html);
                $compile($element.contents())($scope);
                if (!ctrl.$$dragDisabled) {
                    ctrl.$$draggable = Draggable.create(ctrl.$$slider, {
                        type: 'x',
                        lockAxis: true,
                        edgeResistance: .65,
                        dragResistance: .1,
                        throwResistance: .1,
                        maxDuration: 3,
                        throwProps: true,
                        zIndexBoost: false,
                        snap: function (endValue) {
                            ctrl.$$updateIndex(-Math.round(endValue / ctrl.width));
                            return -Math.max(0, Math.min(ctrl.slides.length - ctrl.slideCount, ctrl.index - Math.floor(ctrl.slideCount / 2))) * ctrl.width;
                        },
                        onDragStart: function () {
                            if (ctrl.auto) {
                                $timeout.cancel(ctrl.$$autoRunner);
                            }
                        },
                        onDragEnd: function () {
                            if (ctrl.auto) {
                                ctrl.$$nextAutoStep();
                            }
                        }
                    });
                }
                var updateWidth;
                function getWidth() {
                    $timeout.cancel(ctrl.$$autoRunner);
                    $timeout.cancel(updateWidth);
                    updateWidth = $timeout(function () {
                        ctrl.width = $element.width() / ctrl.slideCount;                 
                        if (ctrl.slides) {
                            ctrl.positionDraggable(false);
                        }
                        if (ctrl.auto) {
                            ctrl.$$nextAutoStep();
                        }
                    });
                }

                win = $($window).on('resize.carousel', getWidth);
                getWidth();

                if (ctrl.onInit) {
                    ctrl.onInit({
                        ctrl: ctrl
                    });
                }
                if (ctrl.auto) {
                    ctrl.$$nextAutoStep();
                }
            });
        }

        ctrl.$$nextAutoStep = function () {
            $timeout.cancel(ctrl.$$autoRunner);
            ctrl.$$autoRunner = $timeout(function () {
                var targetIndex = ctrl.index + ctrl.slideCount;
                var half = Math.floor(ctrl.slideCount / 2);
                if (ctrl.index == 0) {
                    targetIndex += Math.floor(ctrl.slideCount / 2);
                }
                var max = ctrl.slides.length - ctrl.slideCount + half;
                var old = targetIndex;
                if (targetIndex > max) {
                    targetIndex = ctrl.index < max ? max : 0;
                }
                ctrl.goToSlide(targetIndex, true).then(ctrl.$$nextAutoStep);
            }, ctrl.autoInterval);
        }

        ctrl.handleChildEdgeHit = function (direction) {
            if (direction) {
                ctrl.nextSlide();
            }
            else {
                ctrl.prevSlide();
            }
        }

        ctrl.$onDestroy = function () {
            win.off('resize.carousel');
        }

        ctrl.$$registerTransitions = function () {
            $transitions.onStart({
                to: ctrl.route,
                from: function (state) {
                    return state.name !== ctrl.route;
                }
            }, function (transition) {
                ctrl.targetParams = transition.params('to');
                if (!ctrl.blockTransition) {
                    var deferred = $q.defer();
                    var target = ctrl.targetParams[ctrl.routeTarget];
                    if (isNaN(target)) {
                        ctrl.$$findIndexByKey(target, 0, deferred)
                    }
                    else {

                        if (ctrl.parentCarousel) {
                            if (angular.equals(ctrl.parentCarousel.slides[ctrl.parentCarousel.index].images, ctrl.slides)) {
                                deferred.resolve(parseInt(target));
                            }
                            else {
                                deferred.reject('Not active sub slide');
                            }
                        }
                        else {
                            deferred.resolve(parseInt(target));
                        }
                    }
                    deferred.promise.then(function (index) {
                        if (transition.from().name !== ctrl.route && ctrl.onSlideChange) {
                            ctrl.onSlideChange({
                                index: index,
                                slide: ctrl.slides[index]
                            });
                        }
                        ctrl.goToSlide(index, transition.from().name === ctrl.route && !ctrl.parentCarousel);
                    });
                    //return deferred.promise;
                }
                ctrl.blockTransition = false;
            });
            if ($state.current.name === ctrl.route) {
                ctrl.targetParams = angular.copy($stateParams);
                var deferred = $q.defer();
                ctrl.indexResolved = deferred.promise;
                var target = $stateParams[ctrl.routeTarget];
                if (isNaN(target)) {
                    ctrl.$$findIndexByKey(target, 0, deferred)
                }
                else {
                    if (ctrl.parentCarousel) {
                        ctrl.parentCarousel.indexResolved.then(function (index) {
                            if (angular.equals(ctrl.parentCarousel.slides[index].images, ctrl.slides)) {
                                deferred.resolve(parseInt(target));
                            }
                            else {
                                deferred.reject('Not active sub slide');
                            }
                        }).catch(function (response) {
                            deferred.reject('Parent carousel failed to determine index');
                        });
                    }
                    else {
                        deferred.resolve(parseInt(target));
                    }
                }
                deferred.promise.then(function (index) {
                    if (ctrl.onSlideChange) {
                        ctrl.onSlideChange({
                            index: index,
                            slide: ctrl.slides[index]
                        });
                    }
                    $timeout(function () {
                        ctrl.goToSlide(index, false);
                    });
                });
            }
        }

        ctrl.$$findIndexByKey = function (target, start, promise) {
            for (var i = start; i < ctrl.slides.length; i++) {
                if (ctrl.slides[i].urlName === target) {
                    promise.resolve(i);
                    return;
                }
            }
            if (ctrl.paginator) {
                if (!ctrl.paginator.paginationPromise.$resolved) {
                    ctrl.paginator.paginationPromise.$promise.then(function () {
                        ctrl.$$findIndexByKey(target, 0, promise);
                    });
                }
                else {
                    ctrl.paginator.nextPage(function () {
                        ctrl.$$findIndexByKey(target, i, promise);
                    });
                }
            }
            else {
                promise.reject('Key not found');
            }
        }

        ctrl.$$updateIndex = function (index, lockAnimation) {
            if (ctrl.onEdge) {
                if (index >= ctrl.slides.length) {
                    ctrl.onEdge({
                        direction: 1
                    });
                }
                else if (index < 0) {
                    ctrl.onEdge({
                        direction: 0
                    });
                }
            }
            index = Math.min(ctrl.slides.length - 1, Math.max(0, index));
            if (ctrl.index !== index) {
                var next = index > ctrl.index;
                ctrl.index = index;
                if (ctrl.route) {
                    var params = angular.copy(ctrl.targetParams);
                    if (ctrl.slides[index].urlName !== undefined) {
                        if (ctrl.slides[index].urlName !== params[ctrl.routeTarget]) {
                            params[ctrl.routeTarget] = ctrl.slides[index].urlName;
                        }
                    }
                    else {
                        params[ctrl.routeTarget] = ctrl.index;
                    }
                    ctrl.blockTransition = lockAnimation !== undefined ? lockAnimation : true;
                    //$state.go(ctrl.route, params);
                }
                if (ctrl.carouselSync) {
                    ctrl.carouselSync.updateCarousels(index);
                }
                if (ctrl.onSlideChange) {
                    ctrl.onSlideChange({
                        index: index,
                        slide: ctrl.slides[index],
                        ctrl: ctrl
                    });
                }
            }

        }

        ctrl.updateSlides = function (data) {
            ctrl.nextDisabled = data.rows - 1 > ctrl.index;
        }

        ctrl.goToSlide = function (index, animate) {
            ctrl.$$updateIndex(index);
            var animationComplete = ctrl.positionDraggable(animate);
            if (ctrl.index >= 0 && ctrl.index < ctrl.slides.length) {
                ctrl.prevDisabled = ctrl.index === 0;
                ctrl.nextDisabled = ctrl.index >= ctrl.slides.rows - 1;
            }
            return animationComplete;
        }

        ctrl.prevSlide = function () {
            if (ctrl.index === 0 && ctrl.onEdge) {
                ctrl.onEdge({
                    direction: 0
                });
            }
            else {
                ctrl.goToSlide(ctrl.index - 1, true)
            }
        }

        ctrl.nextSlide = function () {
            if (ctrl.index === ctrl.slides.length - 1 && ctrl.onEdge) {
                ctrl.onEdge({
                    direction: 1
                });
            }
            else {
                ctrl.goToSlide(ctrl.index + 1, true)
            }
        }

        ctrl.positionDraggable = function (animate) {
            if (ctrl.slides === null || ctrl.slides.length === undefined)
                return;

            var deferred = $q.defer();
            if (ctrl.$$slider) {
                if (animate) {
                    if (!ctrl.$$dragDisabled)
                        ctrl.$$draggable[0].disable();
                    TweenLite.to(ctrl.$$slider, .8, {
                        throwProps: {
                            x: {
                                velocity: 'auto',
                                end: -Math.max(0, Math.min(ctrl.slides.length - ctrl.slideCount, ctrl.index - Math.floor(ctrl.slideCount / 2))) * ctrl.width
                            }
                        },
                        onComplete: function () {
                            if (!ctrl.$$dragDisabled) {
                                ctrl.$$draggable[0].update();
                                ctrl.$$draggable[0].enable();
                            }
                            $scope.$broadcast('carouselV2.updated');
                            deferred.resolve();
                        }
                    });
                }
                else {
                    TweenLite.set(ctrl.$$slider, {
                        x: -Math.max(0, Math.min(ctrl.slides.length - ctrl.slideCount, ctrl.index - Math.floor(ctrl.slideCount / 2))) * ctrl.width
                    });
                    if (!ctrl.$$dragDisabled) {
                        ctrl.$$draggable[0].update();
                    }
                    deferred.resolve();
                }
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        }
    }
})();